import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { timesheetApi, allocationService, Util } from "../../../services";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Fragment } from "react";
import { toast } from "react-toastify";

const OpenDeallocationDialog = ({ onClose, projectData, onLoad, projectId }) => {
  const [allocType, setAllocType] = useState([]);
  const [updatedAllocationType, setUpdatedAllocationType] = useState("");
  const [isCount, setIsCount] = useState(1);
  const [teamsProjectData, setTeamProjectData] = useState(projectData);
  const [resourceAvail, setResourceAvail] = useState(projectData[0].resourceAvailablity);

  const [resourceRole, setResourceRole] = useState([]);
  const [updatedResourceType, setUpdatedResourceType] = useState("");
  const [billingRate, setBillingRate] = useState([]);
  
  let count = 0
  useEffect(() => {
    if (count == 0) {
      getAllocationtypes();
      getResourceRole(projectId);
      getBillingRate(1)
      count++;
    }
  }, []);
  const getAllocationtypes = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocType(resp?.data?.data);
    });
  };

  const getResourceRole = (proId) => {
    allocationService.getAllResourceRole(proId).then((resp) => {
      setResourceRole(resp?.data?.data);
    });
  };

  const fetchBillable = (i) => {
    var isBillable;
    projectData.map((item) => {
      if (item.id === i) {
        isBillable = item.isBillable;
      }
    });

    return isBillable;
  };

  const getBillingRate = (roleId) => {
    allocationService.getAllBillingRate(roleId).then((resp) => {
      const modifiedData = resp?.data?.data.map(item => ({
        id: item.id,
        rate: `${item.rate} ${item.currency}/${item.billingType.title}`,
      }));
      setBillingRate(modifiedData);
    });
  };

  const editRowComplete = (e) => {
    let prevPercentage;
    let totAvalPercentage;
    let _teamsProjectData = [...teamsProjectData];
    let { newData, index } = e;
    _teamsProjectData[index] = newData;
    const allcPercentage =
      _teamsProjectData[index].allocationType === 1
        ? 100
        : _teamsProjectData[index].allocationType === 2
          ? _teamsProjectData[index].percentage
          : 0;
    prevPercentage = e.data.percentage;
    let allcEndDate;
    if (e.data.endDate === e.newData.endDate) {
      allcEndDate = e.data.endDate;
    } else {
      allcEndDate = Util.dateConverterForAttendance(_teamsProjectData[index].endDate);
    }
    let param = {
      id: [projectData[0].allocationId],
      allocationType: _teamsProjectData[index].allocationType,
      percentage: allcPercentage,
      endDate: allcEndDate,
      isBillable: fetchBillable(_teamsProjectData[index].id),
    };
    if (allcPercentage <= prevPercentage) {
      try {
        allocationService.updateAllocation(param).then(
          (resp) => {
            if (resp) {
              // setTeamProjectData(resp.data.allocations);
              // setResourceAvail(resp.data.availability);
              onClose();
              onLoad();
              toast.success("Allocation updated successfully!");
            }
          },
          (err) => {
            toast.error("Unable to update allocation");
          }
        );
      } catch (error) {
        toast.error("Unable to update allocation");
      }
    } else {
      totAvalPercentage = prevPercentage + resourceAvail;
      if (allcPercentage > totAvalPercentage) {
        toast.error("Allocation percentage should not greater than 100");
      } else {
        try {
          allocationService.updateAllocation(param).then(
            (resp) => {
              if (resp) {
                // setTeamProjectData(resp.data.allocations);
                // setResourceAvail(resp.data.availability);
                onClose();
                onLoad();
                toast.success("Allocation updated successfully!");
              }
            },
            (err) => {
              toast.error("Unable to update allocation");
            }
          );
        } catch (error) {
          toast.error("Unable to update allocation");
        }
      }
    }
  };

  const listEditor = (options) => {
    let list = [];
    let field = "title";
    let fieldval = "id";
    switch (options.field) {
      case "allocationType":
        list = allocType;
        fieldval = "id";
        field = "title";
        setUpdatedAllocationType(options.value);
        return (
          <Fragment>
            <Dropdown value={options.value} options={list} optionLabel={field} optionValue={fieldval} onChange={(e) => options.editorCallback(e.value)} placeholder="Select One"
              itemTemplate={(option) => {
                return <span>{option[field]}</span>;
              }}
            />
          </Fragment>
        );
        break;
      case "percentage":
        if (updatedAllocationType === 1) {
          return (
            <InputText style={{ width: "50px" }} type="integer" value="100" maxLength="2" onChange={(e) => options.editorCallback(parseInt(e.target.value))} disabled />
          );
        } else if (updatedAllocationType === 2) {
          return (
            <InputText style={{ width: "50px" }} type="integer" value={options.value} maxLength="2" onChange={(e) => options.editorCallback(parseInt(e.target.value ? e.target.value : 0))} />
          );
        } else if (updatedAllocationType === 3) {
          return (
            <InputText style={{ width: "50px" }} type="integer" value="0" maxLength="2" onChange={(e) => options.editorCallback(parseInt(e.target.value))} disabled />
          );
        } else {
          return options.value ? options.value : 0;
        }
        break;
      case "userProjectRole":
        list = resourceRole;
        fieldval = "id";
        field = "title";
        setUpdatedResourceType(options.value);
        return (
          <Fragment>
            <Dropdown value={options.value} options={list} optionLabel={field} optionValue={fieldval} onChange={(e) => options.editorCallback(e.value)} placeholder="Select One"
              itemTemplate={(option) => {
                return <span>{option[field]}</span>;
              }}
            />
          </Fragment>
        );
        break;
      case "billingRate":
        list = billingRate;
        fieldval = "id";
        field = "rate";
        // getBillingRate(updatedResourceType);
        return (
          <Fragment>
            <Dropdown value={options.value} options={list} optionLabel={field} optionValue={fieldval} onChange={(e) => options.editorCallback(e.value)} placeholder="Select One"
              itemTemplate={(option) => {
                return <span>{option[field]}</span>;
              }}
            />

            {/* <Dropdown id="billingRate" name="billingRate" placeholder="Select Rate" optionLabel="rate" options={billingRate} onChange={(e) => options.editorCallback(e.value)} value={formik.values.billingRate} appendTo="self" /> */}
          </Fragment>
        );
        break;
      default:
        return "";
    }
  }

  const listBodyTemplate = (options, name) => {
    let listName = "";
    switch (name) {
      case "alType":
        var obj = allocType.find((x) => {
          return x.id === options.allocationType;
        });
        listName = obj?.title;
        break;
      case "percentage":
        listName = options?.percentage;
        break;
      case "userProjectRole":
        listName = options?.userProjectRole;
        break;
      case "billingRate":
        let billingRateTemp = options?.currency + options?.billingRate + " / " + options?.billingType;
        listName = billingRateTemp;
        break;
      default:
        listName = "";
    }
    return listName;
  };

  const endDateEditor = (options) => {
    let dateArray = options.rowData.startDate.split("-");
    let dateObj = new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`);
    return (
      <Calendar showIcon placeholder={options.value} dateFormat="dd-mm-yy" value={options.value} minDate={dateObj} onChange={(e) => options.editorCallback(e.value)} />
    );
  };

  const billableBodyTemplate = (rowData) => {
    return (
      <Checkbox
        id={rowData.id}
        checked={rowData.isBillable}
        onChange={changeBillable}
      />
    );
  }
  const changeBillable = (e) => {
    projectData.map((item) => {
      if (item.id === e.target.id) {
        item.isBillable = !item.isBillable;
      }
    });
    setIsCount(isCount + 1);
  };

  // const deAllocateProject = () => {
  //   confirmDialog({
  //     message: "Do you want to deallocate this record?",
  //     header: "Deallocation Confirmation",
  //     icon: "pi pi-info-circle",
  //     acceptClassName: "p-button-danger",
  //     accept,
  //     reject,
  //   });
  // }

  // const reject = () => {
  //   // onClose();
  // };

  // const accept = () => {
  //   let param = {
  //     ids: [projectData[0].allocationId],
  //   };
  //   timesheetApi.updateDeallocation(param).then(
  //     (resp) => {
  //       if (resp) {
  //         onClose();
  //         onLoad();
  //       }
  //     },
  //     (error) => { }
  //   );
  // };

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <>
  //       <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={deAllocateProject} />
  //       {/* <Button icon="pi pi-pencil" className="p-button-rounded p-button-secondary mr-2" tooltip="Edit Timesheet" tooltipOptions={{ position: "top" }} rowEditor></Button> */}
  //     </>
  //   )
  // }

  return (
    <DataTable value={projectData} rows={10} dataKey="id" editMode="row" onRowEditComplete={editRowComplete}>
      {/* <Column header="Allocation Type" field="allocationType" editor={(options) => listEditor(options)}></Column> */}
      <Column header="Allocation Type" field="allocationType" editor={(options) => listEditor(options)} body={(options) => listBodyTemplate(options, "alType")}></Column>
      <Column header="Percentage(%)" field="percentage" editor={(options) => listEditor(options)} body={(options) => listBodyTemplate(options, "percentage")}></Column>


      <Column header="Resource Role" field="userProjectRole" editor={(options) => listEditor(options)} body={(options) => listBodyTemplate(options, "userProjectRole")}></Column>
      <Column header="Billing Rate" field="billingRate" editor={(options) => listEditor(options)} body={(options) => listBodyTemplate(options, "billingRate")}></Column>


      <Column header="Start Date" field="startDate"></Column>
      <Column header="End date" field="endDate" editor={(options) => endDateEditor(options)}></Column>
      <Column header="Billable" body={billableBodyTemplate}></Column>
      <Column rowEditor></Column>
      {/* <Column body={deleteBody}></Column> */}
      {/* <Column field="" header="" body={actionBodyTemplate}></Column> */}
    </DataTable>
  )
};
export default OpenDeallocationDialog;
